import { PostChannel } from 'src/App/AppPageBlock/graphql/hirer-types.generated';

const validPostChannels: string[] = Object.values(PostChannel);

export const isValidPostChannel = (
  postChannel: string,
): postChannel is PostChannel => validPostChannels.includes(postChannel);
